import React from "react";
import { formatFullTime, formatRelativeTime } from "../../utils/relativeTime";
import "./AppTable.css";

/// Relative ("5 min ago", "Yesterday, 14:20") time for a table cell, with the
/// exact date and time on hover.
const TableTime = ({ value }) => {
  if (!value) return <span className="text-soft">-</span>;
  return (
    <time
      className="app-table-time"
      dateTime={new Date(value).toISOString()}
      title={formatFullTime(value)}
    >
      {formatRelativeTime(value)}
    </time>
  );
};

export default TableTime;
